export default {
  free: 'GRATIS',
  save: 'Spar {{amount}}',
};
